import { Box, Typography } from "@mui/material"
import { CheckCircleFilledRounded } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { NewRequestFormValues } from "../../types"
import { formatFullName } from "../../utils/format"

import type { Location } from "@/graphql/codegen/graphql"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

interface ConfirmedHeaderSummaryProps {
  formValues: Partial<NewRequestFormValues>
}

export const ConfirmedHeaderSummary: FC<ConfirmedHeaderSummaryProps> = ({ formValues }) => {
  const requesterNames = formValues.requesters
    ?.map((requester) => formatFullName(requester.firstName, requester.lastName))
    .join(", ")

  const billingLocationLabel = formValues.customer?.billingLocation
    ? formatLocationAddress(formValues.customer.billingLocation as Location, AddressFormat.LocationAndAddress)
    : ""

  return (
    <Box className='flex flex-col gap-2 rounded border border-gray-400 p-3'>
      {formValues.customer && (
        <Box className='flex items-center gap-3'>
          <CheckCircleFilledRounded className='shrink-0 text-green-600' />
          <Typography className='text-sm text-gray-700'>
            {formValues.customer.company.name}
            {billingLocationLabel && ` - ${billingLocationLabel}`}
          </Typography>
        </Box>
      )}
      {requesterNames && (
        <Box className='flex items-center gap-3'>
          <CheckCircleFilledRounded className='shrink-0 text-green-600' />
          <Typography className='text-sm text-gray-700'>{requesterNames}</Typography>
        </Box>
      )}
    </Box>
  )
}
